export default __webpack_public_path__ + "static/media/send (5).4d0dc42b.svg";